export const CANDIDATES_PATH = '/candidates';
